(function () {
  var root = document.querySelector('[data-flp-review-stack]');
  var track = root && root.querySelector('[data-flp-reviews-track]');
  if (!root || !track || root.getAttribute('data-flp-review-swipe-ready') === 'true') return;

  var mobile = window.matchMedia('(max-width: 860px)');
  var pointer = null;
  var touch = null;
  var suppressClick = false;
  var wheelLocked = false;
  var dragLimit = 104;
  var swipeThreshold = 44;

  root.setAttribute('data-flp-review-swipe-ready', 'true');

  function stopAutoplay() {
    root.setAttribute('data-flp-review-control', 'manual');
    if (typeof root.flpStopReviewAutoplay === 'function') {
      root.flpStopReviewAutoplay();
    }
  }

  function moveStack(deltaX) {
    var value = Math.max(-dragLimit, Math.min(dragLimit, deltaX));
    root.classList.add('is-review-dragging');
    track.style.setProperty('--flp-review-drag-x', value + 'px');
  }

  function resetStack() {
    root.classList.remove('is-review-dragging');
    track.style.removeProperty('--flp-review-drag-x');
  }

  function step(direction) {
    stopAutoplay();
    if (typeof root.flpReviewStep === 'function') {
      root.flpReviewStep(direction);
    }
  }

  function isHorizontal(deltaX, deltaY) {
    return Math.abs(deltaX) >= 10 && Math.abs(deltaX) > Math.abs(deltaY);
  }

  function finishGesture(gesture) {
    var direction = 0;
    if (!gesture) return;

    if (gesture.dragging && Math.abs(gesture.deltaX) >= swipeThreshold) {
      direction = gesture.deltaX < 0 ? 1 : -1;
    }

    resetStack();
    if (direction) step(direction);
  }

  track.addEventListener('pointerdown', function (event) {
    if (!mobile.matches || event.pointerType === 'mouse' && event.button !== 0) return;
    pointer = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      deltaX: 0,
      dragging: false
    };
    suppressClick = false;
    try {
      track.setPointerCapture(event.pointerId);
    } catch (_) {}
  });

  track.addEventListener('pointermove', function (event) {
    var deltaY;
    if (!pointer || pointer.id !== event.pointerId) return;

    pointer.deltaX = event.clientX - pointer.x;
    deltaY = event.clientY - pointer.y;
    if (!pointer.dragging && !isHorizontal(pointer.deltaX, deltaY)) return;

    pointer.dragging = true;
    suppressClick = true;
    stopAutoplay();
    moveStack(pointer.deltaX);
    event.preventDefault();
  }, { passive: false });

  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
    track.addEventListener(type, function (event) {
      var current;
      if (!pointer || pointer.id !== event.pointerId) return;
      current = pointer;
      pointer = null;
      try {
        track.releasePointerCapture(event.pointerId);
      } catch (_) {}
      finishGesture(current);
    });
  });

  if (!window.PointerEvent) {
    track.addEventListener('touchstart', function (event) {
      var point = event.touches && event.touches[0];
      if (!mobile.matches || !point) return;
      touch = {
        x: point.clientX,
        y: point.clientY,
        deltaX: 0,
        dragging: false
      };
      suppressClick = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      var point = event.touches && event.touches[0];
      var deltaY;
      if (!touch || !point) return;

      touch.deltaX = point.clientX - touch.x;
      deltaY = point.clientY - touch.y;
      if (!touch.dragging && !isHorizontal(touch.deltaX, deltaY)) return;

      touch.dragging = true;
      suppressClick = true;
      stopAutoplay();
      moveStack(touch.deltaX);
      event.preventDefault();
    }, { passive: false });

    track.addEventListener('touchend', function () {
      var current = touch;
      touch = null;
      finishGesture(current);
    });

    track.addEventListener('touchcancel', function () {
      touch = null;
      resetStack();
    });
  }

  track.addEventListener('click', function (event) {
    var card = event.target.closest('.flp-review-card');
    if (!card || !mobile.matches) return;

    if (suppressClick) {
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
      return;
    }

    if (card.classList.contains('is-prev') || card.classList.contains('is-next')) {
      event.preventDefault();
      event.stopPropagation();
      step(card.classList.contains('is-next') ? 1 : -1);
    }
  }, true);

  track.addEventListener('wheel', function (event) {
    if (!mobile.matches || wheelLocked || Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 18) return;
    wheelLocked = true;
    event.preventDefault();
    step(event.deltaX > 0 ? 1 : -1);
    window.setTimeout(function () {
      wheelLocked = false;
    }, 420);
  }, { passive: false });

  track.setAttribute('tabindex', '0');
  track.addEventListener('keydown', function (event) {
    if (!mobile.matches || event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    step(event.key === 'ArrowRight' ? 1 : -1);
  });

  function syncViewport() {
    if (!mobile.matches) {
      pointer = null;
      touch = null;
      suppressClick = false;
      resetStack();
      root.removeAttribute('data-flp-review-control');
    }
  }

  if (typeof mobile.addEventListener === 'function') {
    mobile.addEventListener('change', syncViewport);
  } else if (typeof mobile.addListener === 'function') {
    mobile.addListener(syncViewport);
  }
})();
